import styled$1, { css } from 'styled-components';
import { Select as Select$1, color, space, colorSet } from '@ccg/core';
import '@4rk/modular-system';
import { getTypography } from '../../styles/typography.js';
import React$1 from 'react';
import DownSmall from '../Icon/svgs/downSmall.js';

const Select = styled$1(Select$1)`
  select {
    width: 100%;
    resize: none;
    background: ${color('neutral')};
    outline: none;
    padding: ${space(3)} ${space(8)} ${space(2)} ${space(3)};
    border: none;
    border-radius: 0;
    appearance: none;

    option {
      color: inherit;
    }

    &::-ms-expand {
      display: none;
    }

    ${props => props.error && css(["border:2px solid ", ";padding:", " ", " ", " ", ";"], colorSet('accent'), space(2), space(8), space(2), space(2))}
  }

  select::placeholder {
    color: inherit;
    opacity: 0.5;
  }

  label {
    display: block;
    margin-bottom: ${space(2)};
  }

  .select__labelText,
  select {
    ${getTypography.copy}
    display: block;
  }

  .select__optional {
    margin-left: ${space(2)};
    ${getTypography.small}
  }

  .select__description,
  .select__error {
    display: block;
    ${getTypography.small}
  }

  .select__error {
    color: ${colorSet('accent')};
  }

  .select__wrapper {
    position: relative;
    display: inline-block;
  }

  .select__custom-icon {
    pointer-events: none;
    position: absolute;
    top: 50%;
    right: ${space(3)};
    transform: translateY(-50%);

    svg {
      fill: ${colorSet('accent')};
    }
  }
`;
Select.defaultProps = {
  icon: /*#__PURE__*/React$1.createElement(DownSmall, null)
};

export default Select;
